<template>
  <v-container class="pa-0" fluid>
    <v-row class="ma-0 ma-md-2">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <scheduler-calendar
              v-if="organization"
              scope="org"
              :can-edit="canEdit"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import SchedulerCalendar from '../components/scheduler/SchedulerCalendar.vue'

export default {
  name: 'Scheduler',

  components: { SchedulerCalendar },

  computed: {
    ...mapGetters('user', ['organization']),

    canEdit() {
      if (!this.organization) return false
      if (typeof this.organization.canEdit === 'function') {
        return this.organization.canEdit()
      }
      return this.organization.access > 200
    },
  },
}
</script>
